import React from 'react';
import { LogOut, ShieldAlert } from 'lucide-react';
import { useDispatch } from 'react-redux';
import { connectSocket, disconnectSocket } from '@/Redux/Action/socketActions';
import { CommanServices } from '@/services/commanServices';
import { formatInstitutionDateTime } from '../uitilites/institutionTime';

const read = (key) => {
  try { const value = localStorage.getItem(key); return value ? JSON.parse(value) : null; } catch (_) { return null; }
};

export default function SupportSessionBanner() {
  const dispatch = useDispatch();
  const session = read('support_session');
  if (!session) return null;

  const exit = () => {
    const backup = read('platform_session_backup');
    dispatch(disconnectSocket());
    if (backup?.access_token) {
      localStorage.setItem('access_token', backup.access_token);
      localStorage.setItem('user', JSON.stringify(backup.user || {}));
      if (backup.active_institution) localStorage.setItem('active_institution', backup.active_institution);
      else localStorage.removeItem('active_institution');
      CommanServices.setToken(backup.access_token);
      dispatch(connectSocket(backup.access_token));
    } else {
      localStorage.removeItem('access_token');
      localStorage.removeItem('user');
    }
    localStorage.removeItem('support_session');
    localStorage.removeItem('platform_session_backup');
    window.location.assign(backup?.access_token ? (backup.return_path || '/support-access') : '/login');
  };

  return <div className={`flex min-h-10 items-center justify-between gap-4 px-4 py-2 text-sm font-semibold text-white ${session.break_glass ? 'bg-red-700' : 'bg-amber-600'}`} role="status"><span className="flex items-center gap-2"><ShieldAlert className="h-4 w-4" />{session.break_glass ? 'BREAK-GLASS' : 'TEMPORARY SUPPORT'} · {session.institution_name || 'Institution'} · {session.read_only ? 'Read-only' : 'Emergency write access'} · Expires {formatInstitutionDateTime(session.expires_at, session.institution_timezone)}</span><button type="button" onClick={exit} className="inline-flex shrink-0 items-center gap-1 rounded bg-white/15 px-3 py-1 hover:bg-white/25"><LogOut className="h-4 w-4" /> Exit support session</button></div>;
}
